import styled from "styled-components";
import { TableCell } from "@mui/material";

import Status from "@/components/atoms/Status/Status";

export const StyledActivityItem = styled(TableCell)`
    position: relative;
    padding: 0 16px;
    cursor: default;
`;

export const StyledDescription = styled.p`
    color: var(--color-grey-900);
    @supports (-webkit-line-clamp: 3) {
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: initial;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
`;

export const StyledStatus = styled(Status)`
    position: absolute;
    top: 10px;
    right: 0;
    width: 80px;
`;

export const StyledDate = styled.p`
    width: 110px;
`;
